import {
  getTokenTransfers
} from '../../config/apiServe/scanner'
export default {
  props: {
    addr: '',
    token: '',
    tokenAddress: '', // Token合约地址
    pages: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  data() {
    return {
      Trades: [],
      balance: 0,
      loading: false
    }
  },
  watch: {
    addr(val) {
      this.$router.push({
        path: '/tokenDetail',
        query: {
          tokenAdr: this.tokenAddress,
          adr: val
        }
      })
      this.loadTransfers()
    },
    pages: {
      handler(newPages, oldPages) {
        this.loadTransfers()
      },
      deep: true
    },
    tokenAddress(newVal) {
      if (newVal) {
        this.loadTransfers()
      }
    }
  },
  mounted() {
    if (this.tokenAddress) {
      this.loadTransfers()
    }
    if (this.addr !== '') {
      this.getTokenBalance()
    }
  },
  methods: {
    // 加载Transfer记录
    async loadTransfers() {
      if (!this.tokenAddress) return;
      
      this.loading = true;
      try {
        const params = {
          page: this.pages.currentPage,
          size: this.pages.pageSize
        };
        
        // 如果指定了地址，添加from过滤（筛选该地址作为发送方的交易）
        // 注意：如果需要同时显示发送和接收，可能需要分别查询from和to然后合并
        if (this.addr && this.addr !== '') {
          params.from = this.addr;
        }
        
        const response = await getTokenTransfers(this.tokenAddress, params);
        if (response.code === 0 && response.data) {
          const { transfers, total } = response.data;
          console.log(transfers,'transfers');
          
          if(transfers.length > 0) {
          // 转换数据格式以适配组件
            this.Trades = transfers.map(item => ({
              hash: item.tx_hash, // 交易哈希
              tx_hash: item.tx_hash,
              from: item.from, // 发送方
              to: item.to, // 接收方
              block_time: item.block_time, // 区块时间
              block_number: item.block_number, // 区块号
              value: item.value, // 原始值
              value_formatted: item.value_formatted, // 格式化后的值
              token_symbol: item.token_symbol, // 代币符号
              token_decimals: item.token_decimals, // 代币精度
              // 为了兼容TradeValue过滤器，添加以下字段
              amount: parseFloat(item.value_formatted || 0) * 100000000, // 转换为旧格式（假设8位小数）
              assets: [{
                symbol: item.token_symbol,
                amount: parseFloat(item.value_formatted || 0) * 100000000,
                exec: 'token'
              }],
              success: true, // 默认成功
              is_para: false
            }));
          }
          this.pages.total = total || 0;
        } else {
          this.Trades = [];
          this.pages.total = 0;
          this.$notify.error({
            title: '提示',
            message: response.message || '数据请求失败'
          });
        }
      } catch (error) {
        console.error('加载Transfer记录失败:', error);
        this.Trades = [];
        this.pages.total = 0;
        // this.$notify.error({
        //   title: '提示',
        //   message: '数据请求失败'
        // });
      } finally {
        this.loading = false;
      }
    },
    // 获取地址下token余额（如果需要，可以调用其他接口）
    getTokenBalance() {
      // 新接口可能不提供余额信息，这里保留接口但可能需要调用其他服务
      // 暂时设置为0，如果需要可以从其他地方获取
      this.balance = 0;
    },
    success() {
      this.$message.success(this.$t("components.copySuc"));
    },
    error() {
      this.$message.warning(this.$t("components.copyErr"));
    }
  }
}